<template>
    <page title="Verification">
        <template #pageContainer>
        </template>
    </page>
</template>

<script>
import Page from '../general/Page.vue';

export default {
	name: 'Verification',
	components: {
		Page,
	},
};
</script>
